export default __webpack_public_path__ + "static/media/pdf.6ffbb2e0.svg";